import React from 'react'
import styled from 'styled-components'
import {getLocationSetter} from 'utils/browserUtils'
import config from 'config'
import {HeaderLogo, LogosContainer} from './HeaderLogosStyles'

const WinterAwardsPrimaryLogo = styled(HeaderLogo)`
  height: ${props => (props.isScrolling ? '50px' : '64px')};
`

const WinterAwardsLogos = ({lang, isScrolling}) => {
  const isFrench = lang === 'fr'

  return (
    <LogosContainer>
      <WinterAwardsPrimaryLogo
        src={`${config.url}/assets/brands/blick/winter-awards/logo-blick-winter-awards.svg`}
        onClick={getLocationSetter(`https://winterawards.ch/${isFrench ? 'fr' : ''}`)}
        isScrolling={isScrolling}
      />
    </LogosContainer>
  )
}

export default WinterAwardsLogos
